// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-LeftSide-module--cls1--t7tl3","cls2":"styles-LeftSide-module--cls2--3YauV styles-LeftSide-module--cls1--t7tl3"};